import type { RootCouriersState } from 'app/store/root/couriers/couriers.reducer';
import type { DocumentsState } from 'app/store/root/documents/documents.reducer';
import type { ProjectsState } from 'app/store/root/projects/projects.reducer';
import type {
  SimpleExtensionsState,
} from 'app/store/root/simple-extensions/simple-extensions.reducer';
import type { UsersState } from 'app/store/root/users/users.reducer';
import type { WebhooksState } from 'app/store/root/webhooks/webhooks.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { initialRootCouriersState } from 'app/store/root/couriers/couriers.reducer';
import { initialDocumentsState } from 'app/store/root/documents/documents.reducer';
import { initialProjectsState } from 'app/store/root/projects/projects.reducer';
import {
  initialSimpleExtensionsState,
} from 'app/store/root/simple-extensions/simple-extensions.reducer';
import { initialUsersState } from 'app/store/root/users/users.reducer';
import { initialWebhooksState } from 'app/store/root/webhooks/webhooks.reducer';

const rootFeatureKey = 'root';

export const selectRootState = createFeatureSelector<RootState>(rootFeatureKey);

export interface RootState {
  projects: ProjectsState;
  users: UsersState;
  documents: DocumentsState;
  webhooks: WebhooksState;
  couriers: RootCouriersState;
  simpleExtensions: SimpleExtensionsState;
}

export const initialRootState: RootState = {
  projects: initialProjectsState,
  users: initialUsersState,
  documents: initialDocumentsState,
  webhooks: initialWebhooksState,
  couriers: initialRootCouriersState,
  simpleExtensions: initialSimpleExtensionsState,
};
